import { Flex, Image } from "antd";
import { Fade } from "react-awesome-reveal";
import img from "../images/23.JPG";
import MyText from "../../../components/UI/Text/MyText";
import { clrs } from "../../../constants/colors";
import HorizontalDivider from "../../../components/Divider/HorizontalDivider";
import { Link } from "react-router-dom";
import { LinkOutlined } from "@ant-design/icons";
import React from "react";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";

export const PersonZhalmagambetova = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40} wrap="wrap">
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img} width={240} preview={false} style={{ borderRadius: 16 }} />
                </Fade>
                <Flex style={{ flex: 1, minWidth: 200, position: "relative" }} vertical>
                    <MyText strong size={"large"}><IntlMessage id={'team.person.zhalmagambetova.fullName'}/></MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        <IntlMessage id={'team.person.zhalmagambetova.title'}/>
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <Flex gap={12} wrap={"wrap"} vertical>
                        <Link target={"_blank"} to={'https://www.scopus.com/authid/detail.uri?authorId=57202369438'}>
                            <MyText><LinkOutlined /> Scopus</MyText>
                        </Link>
                        <Link target={"_blank"} to={'https://orcid.org/0000-0002-2261-2222'}>
                            <MyText><LinkOutlined /> ORCID</MyText>
                        </Link>
                    </Flex>
                    <br />
                    <MyText strong size={"small"}><IntlMessage id={'team.section.workplace'}/></MyText>
                    <MyText><IntlMessage id={'team.person.zhalmagambetova.workplace'}/></MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.section.role'}/></MyText>
                <MyText size={"small"} italic><IntlMessage id={'team.person.zhalmagambetova.role'}/></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.role.1'}/>
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.role.2'}/>
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.role.3'}/>
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.section.justification'}/></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.justification'}/>
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.section.researchProjects'}/></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.projects.1'}/>
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.projects.2'}/>
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}><IntlMessage id={'team.section.publications'}/></MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.publications.1'}/>
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    <IntlMessage id={'team.person.zhalmagambetova.publications.2'}/>
                </MyText>
            </Flex>
        </Flex>
    );
};
